import { animate, style, transition, trigger } from '@angular/animations';
import { Component, computed, input, linkedSignal, model } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideChevronRight, lucideEllipsisVertical } from '@ng-icons/lucide';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';
import { HlmTooltipImports } from '@spartan-ng/helm/tooltip';

import { ExpansionPanelMenuAction } from '../expansion-panel/expansion-panel.component';

@Component({
  selector: 'app-expansion-panel-without-border',
  imports: [NgIcon, HlmButton, HlmTooltipImports, HlmDropdownMenuImports],
  templateUrl: './expansion-panel-without-border.component.html',
  providers: [provideIcons({ lucideChevronRight, lucideEllipsisVertical })],
  animations: [
    trigger('expandCollapse', [
      transition(':enter', [style({ height: '0', opacity: 0 }), animate('30ms', style({ height: '*', opacity: 1 }))]),
      transition(':leave', [style({ height: '*', opacity: 1 }), animate('30ms', style({ height: '0', opacity: 0 }))]),
    ]),
  ],
})
export class ExpansionPanelWithoutBorder<T> {
  readonly titre = input.required<string>();
  readonly item = input<T>();
  readonly actions = input<ExpansionPanelMenuAction<T>[]>();
  readonly width = computed(() => (this.actions()?.length ? 'calc(100% * 6/8)' : 'calc(100% * 8/9)'));
  readonly mustBeOpen = input<boolean>(false);

  isOpen = linkedSignal(() => this.mustBeOpen());

  toggle() {
    this.isOpen.update((x) => !x);
  }
}
